import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { FacebookConnectButton } from 'components/FacebookSDK/FacebookConnectButton';
import {
  FACEBOOK_FORM,
  facebookFormAction,
  initializeFacebookForm,
  watchFacebookFormSagas,
} from '../sagas/facebook.saga';

export class FacebookFormUnwrapped extends PureComponent {
  componentDidMount() {
    this.props.onMount(this.props.hiddenFields);
  }

  render() {
    const { handleSubmit, isDisabled, submitSucceeded: hasSucceeded, submitting: isSubmitting } = this.props;

    return (
      <form method="post" onSubmit={handleSubmit} noValidate>
        <FacebookConnectButton
          className={classNames({
            'bt bt--lg bt--width-full bt--facebook': true,
            'bt--waiting': isSubmitting,
          })}
          disabled={!!(hasSucceeded || isSubmitting || isDisabled)}>
          <FormattedMessage id="signup-card.lead.facebook-action" defaultMessage="Sign up with Facebook" />
        </FacebookConnectButton>
      </form>
    );
  }
}

FacebookFormUnwrapped.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  hiddenFields: PropTypes.object,
  isDisabled: PropTypes.bool,
  onMount: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
};

const formConfig = {
  enableReinitialize: true,
  form: FACEBOOK_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: facebookFormAction,
  onSubmitSuccess: (result, dispatch, props) => props.onSuccess(result),
};

export const FacebookForm = decorateWith(
  withSagas({ watch: watchFacebookFormSagas }),
  connect(
    null,
    { onMount: initializeFacebookForm }
  ),
  reduxForm(formConfig),
  withName('FacebookForm')
)(FacebookFormUnwrapped);
